module.exports = __webpack_public_path__ + "img/umis-logo.8c9eb8ef.png";